import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { BookingContext } from "../Context";
import dataFetcher from "hooks/bookService";
import OurServicesPaymentFormField from "./Form";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Loader } from "ui/Loader";
import CalculOpperator from "helpers/CalculOpperator";
import Footer from "components/Layout/Main/Footer";
import { buildRoute, ROUTES } from "routes";

const stripePromise =
    process.env.REACT_APP_STRIPE_API_KEY_PUBLIC && loadStripe(process.env.REACT_APP_STRIPE_API_KEY_PUBLIC);

const OurServicesPayment: React.FC = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { getBooking } = useContext(BookingContext);
    const [clientSecret, setClientSecret] = useState<string>("");
    const [paymentIntent, setPaymentIntent] = useState<string>("");
    const bookingData = useMemo(() => {
        return getBooking();
    }, [getBooking]);

    useEffect(() => {
        const fetchData = async () => {
            if (bookingData?.id && bookingData) {
                const opperateur = new CalculOpperator(null);
                const [managementFeesValue, totalPrice] = opperateur.computeTTC(parseFloat(bookingData.price) * bookingData.nb_hours);
                bookingData.amount = bookingData?.activate_cesu_plus === '1' || bookingData?.cesu_plus_status ? managementFeesValue.toString() : totalPrice.toString();

                const paymentIntent = await dataFetcher.createPayment({
                    id: bookingData?.id,
                    data: {
                        amount: bookingData.amount,
                    },
                });
                setPaymentIntent(paymentIntent.id);
                setClientSecret(paymentIntent.client_secret);
            } else {
                navigate(id ? buildRoute.provider(String(id)) : ROUTES.HOME);
            }
        };

        fetchData();
    }, [bookingData, id, navigate]);

    const options = {
        clientSecret: clientSecret,
        apparence: "stripe",
    };

    return (
        <React.Fragment>
            <div className="our_services">
                <div className="block-header">
                    <div className="container">
                        <h1 className="block-header__title">Réservation d'une <span>prestation</span></h1>
                    </div>
                </div>
                <div className="container">
                    {clientSecret && stripePromise ? (
                        <Elements stripe={stripePromise} options={options}>
                            <OurServicesPaymentFormField paymentIntent={paymentIntent} />
                        </Elements>
                    ) : (
                        <Loader />
                    )}
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
};

export default OurServicesPayment;
